import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const Emp_TimecardDetail: React.FC = () => {
  const { date, time } = useParams<{ date: string; time: string }>();
  const navigate = useNavigate();
  const timecardDetails = useSelector((state: RootState) => state.timecardDetails.details);

  const detail = timecardDetails.find((d) => d.date === date && d.clockInTime === time);

  if (!detail) {
    return (
      <div className="p-4 text-center text-red-600 font-semibold text-sm">
        No details found for this date and time.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white w-full max-w-md mx-auto overflow-y-auto">
     <div className="bg-white p-4 flex items-center">
  <button onClick={() => navigate(-1)} className="text-black mr-2">
    {/* <IoMdArrowBack size={24} /> */}
    <ChevronLeft size={24} />
  </button>
  <h2 className="text-black text-lg font-semibold flex-grow text-center">Time Card Details</h2>
     </div>
      <div className="p-4">
        <p className="text-gray-600 text-sm mb-1">Total duration:</p>
        <p className="text-2xl font-bold mb-4">{detail.totalDuration}</p>
        <hr className="mb-4" />

        <div className="grid grid-cols-2 text-sm mb-4">
          <div>
            <p className="text-gray-600">Clock In</p>
            <p className="font-bold text-lg">{detail.clockInTime}</p>
            <p className="text-gray-600 text-sm">{detail.date}</p>
          </div>
          <div className="text-right">
            <p className="text-gray-600">Clock Out</p>
            <p className="font-bold text-lg">{detail.clockOutTime}</p>
            <p className="text-gray-600 text-sm">{detail.date}</p>
          </div>
        </div>

        {['Site', 'Paycode', 'Job Code', 'Department', 'Shift', 'Break'].map((field, idx) => (
          <div key={field} className="flex justify-between py-2 border-b border-gray-200">
            <span className="text-gray-600 text-sm">{field}</span>
            <span className="font-semibold text-sm">
              {detail[field.toLowerCase() as keyof typeof detail] || '--'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Emp_TimecardDetail;





